import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Tag from '../components/Tag';
import Alert from '../components/Alert';
import { useAddServerMutation } from '../RTK/ApiRequests';

const AddServer = ({ username }) => {
  const [tags, setTags] = useState([]);
  const [AddServer] = useAddServerMutation();

  const [serverData, setServerData] = useState({
    Owner: username,
    serverName: "",
    ip: "",
    serverPort: "",
    votifierIP: "",
    votifierPort: "",
    votifierPublicKey: "",
    bannerImg: "",
    description: "",
    tags: []
  });

  const [alertText, setAlertText] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setServerData({
      ...serverData,
      [name]: value
    });
  };

  const handleTagAdd = (e) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedTag = selectedOption.value;
    if (selectedTag.trim() !== '') {
      if (tags.length < 3) {
        if (!tags.includes(selectedTag.trim())) {
          setTags([...tags, selectedTag.trim()]);
          setServerData({
            ...serverData,
            tags: [...tags, selectedTag.trim()]
          });
        } else {
          console.log('Tag already exists!');
        }
      } else {
        console.log('You can only add up to 3 tags.');
      }
    }
  };

  const handleTagRemove = (tagToRemove) => {
    setTags(tags.filter(tag => tag !== tagToRemove));
    setServerData({
      ...serverData,
      tags: tags.filter(tag => tag !== tagToRemove)
    });
  };

  const handleBanner = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const img = new Image();
        img.onload = function () {
          if (img.width === 468 && img.height === 60 && file.size <= 1024 * 1024) {
            setServerData({
              ...serverData,
              bannerImg: reader.result
            });
          } else {
            setAlertText('Please upload an image with resolution 468x60 pixels and maximum size 1MB.');
          }
        };
        img.src = reader.result;
      };
      if (file.type.startsWith('image/')) {
        reader.readAsDataURL(file);
      } else {
        setAlertText('Invalid file type. Please select an image.');
      }
    }
  };

  const handleClick = async (e) => {
    e.preventDefault();
    const { Owner, serverName, ip, serverPort, votifierIP, votifierPort, votifierPublicKey, bannerImg, description, tags } = serverData;
    const randomID = Math.floor(Math.random() * 99999);

    if (serverName === '' || ip === '' || serverPort === '' || bannerImg === '' || description === '' || tags.length < 1) {
      setAlertText('Please fill out all fields that are marked with *');
    } else {
      const res = await AddServer({
        serverID: randomID,
        Owner,
        serverName,
        ip,
        serverPort,
        votifierIP,
        votifierPort,
        votifierPublicKey,
        bannerImg,
        description,
        tags
      });

      if (!res.error) {
        window.location.href = '/servers/my-servers';
      } else {
        setAlertText(res.error.data.message);
      }
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setAlertText('');
    }, 10000);
    return () => clearTimeout(timer);
  }, [alertText]);

  return (
    <AddServerWrapper>
      <h3>Add Server</h3>
      <form onSubmit={handleClick}>
        <p style={{
          fontSize: '2rem',
          fontWeight: 'bold',
          marginBottom: '3rem',
        }}>Mandatory fields marked with <span>*</span></p>
        <label htmlFor="serverName"><span>*</span>Server Name</label>
        <input type="text" id='serverName' name="serverName" placeholder='Server Name' value={serverData.serverName} onChange={handleChange} />
        <p style={{
          textAlign: 'left',
          fontWeight: 'bold',
          color: 'orange'
        }}>Only enter the server name, nothing else.</p>
        <label htmlFor="ip"><span>*</span>IP</label>
        <input type="text" id='ip' name="ip" placeholder='IP' value={serverData.ip} onChange={handleChange} />
        <p style={{
          textAlign: 'left',
          fontWeight: 'bold',
          color: 'orange'
        }}>Do not enter the server port here.</p>
        <label htmlFor="serverPort"><span>*</span>Server Port</label>
        <input type="text" id='serverPort' name='serverPort' placeholder='Server Port' value={serverData.serverPort} onChange={handleChange} />
        <label htmlFor="votifierIP">Votifier IP</label>
        <input type="text" id='votifierIP' name='votifierIP' placeholder='Votifier IP' value={serverData.votifierIP} onChange={handleChange} />
        <label htmlFor="votifierPort">Votifier Port</label>
        <input type="number" id='votifierPort' name='votifierPort' placeholder='Votifier Port' value={serverData.votifierPort} onChange={handleChange} />
        <label htmlFor="votifierPublicKey">Votifier Public Key</label>
        <textarea cols={'50'} rows={'10'} type="text" id='votifierPublicKey' name='votifierPublicKey' placeholder='Votifier Public Key' value={serverData.votifierPublicKey} onChange={handleChange} />
        <p style={{
          textAlign: 'left',
          fontWeight: 'bold',
          color: 'orange'
        }}>Votifier Public Key must be accurate.</p>
        <label htmlFor="bannerImg"><span>*</span>Banner Image</label>
        <input type="file" name="bannerImg" id="bannerImg" accept="image/gif, image/png, image/jpeg" onChange={handleBanner} />
        <p style={{
          textAlign: 'left',
          fontWeight: 'bold',
          color: 'orange'
        }}>Resolution 468x60 pixels, maximum size 1MB.</p>
        <label htmlFor="description"><span>*</span>Description</label>
        <textarea cols={'50'} rows={'10'} type="text" id='description' name='description' placeholder='Description' value={serverData.description} onChange={handleChange} />
        <label htmlFor="tags-selector"><span>*</span>Tags</label>
        <div>
          {tags.map((tag, index) => (
            <Tag key={index} label={tag} onClick={() => handleTagRemove(tag)} />
          ))}
        </div>
        <select
          multiple
          name="tags[]"
          id="tags-selector"
          required
          className="select2 select2-hidden-accessible"
          data-select2-id="tags-selector"
          onChange={handleTagAdd}
        >
          <option value="Bedwars">Bedwars</option>
          <option value="Survival">Survival</option>
          <option value="SkyBlock">SkyBlock</option>
          <option value="Prison">Prison</option>
          <option value="Faction">Faction</option>
          <option value="Minigames">Minigames</option>
          <option value="RPG">RPG</option>
          <option value="Anarchy">Anarchy</option>
          <option value="Practice">Practice</option>
          <option value="Touny">Touny</option>
          <option value="Modded">Modded</option>
          <option value="Cobblemon">Cobblemon</option>
          <option value="Skywars">Skywars</option>
          <option value="Lifesteal">Lifesteal</option>
          <option value="Earth">Earth</option>
          <option value="Gens">Gens</option>
          <option value="PVE">PVE</option>
          <option value="OneBlock">OneBlock</option>
          <option value="Parkour">Parkour</option>
          <option value="Pixelmon">Pixelmon</option>
        </select>
        <p style={{
          textAlign: 'left',
          fontWeight: 'bold',
          color: 'orange'
        }}>3 tags are maximum.</p>
        {
          alertText !== '' ? <Alert content={alertText} /> : null
        }
        <button type='submit'>Add Server</button>
      </form>
    </AddServerWrapper >
  );
};

const AddServerWrapper = styled.section`
  width: 100vh;
  margin: 5rem auto;
  border-radius: 5px;

  @media (max-width: ${(({ theme }) => theme.media.mobile)}) {
    width: 95%;
  }

  h3 {
    padding: 10px;
    background-color: #494949;
    color: #fff;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }
  
  form {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding: 30px 60px;
    background-color: #fff;
    border: 2px solid #C7DCDF;
    border-radius: 4px;

    label {
      cursor: pointer;
      font-size: 20px;
      font-weight: 700;
      line-height: 1.25;
      color: #494949;
      margin-bottom: 5px;
    }

    span {
      color: red;
    }

    input {
      outline: none;
      background-color: #F0F2F6;
      border: 2px solid #58678C;
      border-radius: 4px;
      padding: 10px 40px 10px 15px;
      color: #494949;
      font-size: 16px;
      display: block;
      z-index: 1;
      position: relative;
      width: 100%;
      text-transform: unset;
    }

    select {
      cursor: pointer;
      outline: none;
      background-color: #F0F2F6;
      border: 2px solid #58678C;
      border-radius: 4px;
      padding: 10px 40px 10px 15px;
      color: #494949;
      font-size: 16px;
      display: block;
      z-index: 1;
      position: relative;
      width: 100%;
      text-transform: unset;
    }

    textarea {
      outline: none;
      background-color: #F0F2F6;
      border: 2px solid #58678C;
      border-radius: 4px;
      padding: 10px 40px 10px 15px;
      color: #494949;
      font-size: 16px;
      display: block;
      z-index: 1;
      position: relative;
      width: 100%;
      text-transform: unset;
    }

    button {
      display: block;
      border: none;
      color: #fff;
      text-align: center;
      font-weight: 600;
      font-size: 20px;
      padding: 1rem;
      text-transform: uppercase;
      margin-bottom: 0;
      background-color: #3BA61C;
      cursor: pointer;
    }
  }

  p {
    text-align: center;
    padding: 1rem;
  }

  #register {
    background-color: #58678C;
    display: block;
    border: none;
    color: #fff;
    text-align: center;
    font-weight: 600;
    font-size: 20px;
    padding: 1rem;
    text-transform: uppercase;
    margin-bottom: 0;
    cursor: pointer;
    width: 100%;
    margin: 0 auto;
  }
`;

export default AddServer;
